import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

import { MatDialogModule } from '@angular/material/dialog';

import { TranslateModule } from '@ngx-translate/core';

import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';

import { UiButtonModule } from '@cigna/ui/button';
import { UiIconModule } from '@cigna/ui/icon';
import { UiInputModule } from '@cigna/ui/input';
import { AnalyticsUiModule } from '@cigna/analytics/ui';

import { ChcpShellUiModule } from '@cigna/chcp/shell/ui';
import { ChcpSharedEnvironmentUtilModule } from '@cigna/chcp/shared/environment-util';
import { ChcpSharedUiModule } from '@cigna/chcp/shared/ui';
import { ChcpRoutes } from '@cigna/chcp/shared/util';

import { LoginEffects } from './+state/login.effects';
import { LOGIN_FEATURE_KEY, loginReducer } from './+state/login.reducer';

import { PageComponent } from './page/page.component';
import { LoginFormComponent } from './login-form/login-form.component';
import { QuickAccessLinksComponent } from './quick-access-links/quick-access-links.component';
import { CignaResourcesComponent } from './cigna-resources/cigna-resources.component';
import { DialogWhatIsTempIdComponent } from './dialog-what-is-temp-id/dialog-what-is-temp-id.component';
import { LoginMessageComponent } from './login-message/login-message.component';

const routes: ChcpRoutes = [
  {
    path: '',
    pathMatch: 'full',
    component: PageComponent,
    data: {
      title: 'Login',
      analytics: {
        name: 'Login',
        section: 'Login',
        // TODO: resolve CHCP disables by bot
        // eslint-disable-next-line sonarjs/no-duplicate-string
        prop13: 'pv-Login001-US1012734-Login Pageview',
        loggedIn: false,
      },
    },
  },
  {
    path: 'vic',
    pathMatch: 'full',
    component: PageComponent,
    data: {
      title: 'Login',
      analytics: {
        name: 'Login',
        section: 'Login',
        prop13: 'pv-Login001-US1012734-Login Pageview',
        loggedIn: false,
      },
    },
  },
  {
    path: 'ExternalTableau',
    pathMatch: 'full',
    component: PageComponent,
    data: {
      title: 'Login',
      analytics: {
        name: 'Login',
        section: 'Login',
        prop13: 'pv-Login001-US1012734-Login Pageview',
        loggedIn: false,
      },
    },
  },
];

@NgModule({
  imports: [
    CommonModule,
    MatDialogModule,
    ReactiveFormsModule,
    UiInputModule,
    AnalyticsUiModule,
    UiButtonModule,
    UiIconModule,
    TranslateModule,
    ChcpSharedUiModule,
    ChcpSharedEnvironmentUtilModule,
    ChcpShellUiModule,
    RouterModule.forChild(routes),
    TranslateModule,
    StoreModule.forFeature(LOGIN_FEATURE_KEY, loginReducer),
    EffectsModule.forFeature([LoginEffects]),
  ],
  declarations: [
    PageComponent,
    LoginFormComponent,
    QuickAccessLinksComponent,
    CignaResourcesComponent,
    DialogWhatIsTempIdComponent,
    LoginMessageComponent,
  ],
})
export class ChcpLoginShellFeatureModule {}
